import React, {useState} from 'react';
import {useEffect} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {getCurrentLang} from '../../../utils/i18n';

const ReaderCollapsableFooter = props => {
    const [height, setHeight] = useState(0);
    const [canAppear, setCanAppear] = useState(false);

    useEffect(() => {
        if (props.collapsed) {
            setHeight(0);
            //collapsed once, it can now appear
            setCanAppear(true);
        } else if (canAppear) {
            setHeight(62);
        }
    }, [props.collapsed, canAppear]);

    const {t} = useTranslation();
    let prevEnabled = props.chapter.number > 1;
    let nextEnabled = props.chapter.number < props.comic.chapters.length;

    const user = useSelector(state => state.user);
    const idp = user && user.idp;

    const trackNext = () => {
        window.turner_metadata.trackAction.push({
            type: 'interaction',
            data: {
                interaction: 'comic|next chapter',
                domain: 'cnplus.com',
                brand: 'cartoon network',
                server: 'cnplus',
                platform: 'web',
                region: 'latam',
                country:
                    user && user.countryIsoCode && user.countryName
                        ? `${user.countryIsoCode.toLowerCase()}|${
                              user.countryName
                          }`
                        : 'not loaded',
                interactionevent: '1',
                authstate:
                    user && user.jwtToken ? 'authenticated' : 'unauthenticated',
                mvpd: idp || 'idp not loaded',
                userlang: getCurrentLang(),
                franchise: props.comic.show,
                contenttype: 'comics',
                contenttitle: props.comic.title,
                chapter_number: String(props.chapter.number),
                english_name: props.comic.englishTitle.toLowerCase(),
                nextchapter_event: '1',
            },
        });
    };

    return (
        <Container height={height}>
            <ButtonContainer
                to={`/comics/${props.comic.friendlyName}/${props.chapter
                    .number - 1}`}
                enabled={prevEnabled}
                replace
            >
                <ImagePrev
                    src={require('../../../assets/ic-comics-next.png')}
                    enabled={prevEnabled}
                />
                <ButtonText enabled={prevEnabled}>
                    {t('comics.previous')}
                </ButtonText>
            </ButtonContainer>
            <ButtonContainer
                enabled={nextEnabled}
                to={`/comics/${props.comic.friendlyName}/${props.chapter
                    .number + 1}`}
                replace
            >
                <ImageNext
                    src={require('../../../assets/ic-comics-next.png')}
                    enabled={nextEnabled}
                    onClick={trackNext}
                />
                <ButtonText enabled={nextEnabled}>
                    {t('comics.next')}
                </ButtonText>
            </ButtonContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: 1024px;
    align-items: center;
    background-color: black;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 0px;
    overflow: hidden;
    position: absolute;
    bottom: 0px;
    height: ${props => props.height}px;
    transition: height 0.2s;
    z-index: 2;
`;

const ButtonText = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    opacity: ${props => (props.enabled ? 1 : 0.5)};
`;

const ButtonContainer = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0px 16px;
    pointer-events: ${props => (props.enabled ? 'all' : 'none')};
    color: transparent;
`;

const ImageNext = styled.img`
    opacity: ${props => (props.enabled ? 1 : 0.5)};
    margin-bottom: 8px;
`;

const ImagePrev = styled(ImageNext)`
    transform: scaleX(-1);
`;

export default ReaderCollapsableFooter;
